import axios from '@config/axios-config';
import { IApiResponse } from '@datatype/common/api-type';
import { ICreateContactRequest } from '@datatype/hub/api-type';

// 문의 및 의견 api
export const createContactApi = async (input: ICreateContactRequest): Promise<IApiResponse<void>> => {
  const { service, email, subject, content } = input;
  const body = { service, email, subject, content };
  const response = await axios.post<IApiResponse<void>>('/api/v1/hub/contact', body).then((res) => res.data);
  return response;
};
